import { render, staticRenderFns } from "./ModalPayWithBankTransfer.vue?vue&type=template&id=d59face4"
import script from "./ModalPayWithBankTransfer.vue?vue&type=script&lang=js"
export * from "./ModalPayWithBankTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports